jQuery(document).ready(function ($) {

  const $forms = $('.js-recras-form');

  if (!$forms.length) {
    return;
  }

  $forms.on('submit', function(event) {
    event.preventDefault();

    const $form = $(this);
    const $submitButton = $form.find('[type="submit"]');

    const payload = serializeForm($form);

    if (!validateForm(payload, $form)) {
      return;
    }

    $submitButton.prop('disabled', true);

    $.ajaxWithRecaptcha({
        url: window.g4zRecras.ajaxUrl,
        method: 'POST',
        dataType: 'json',
        data: {
          action: window.g4zRecras.action,
          nonce: window.g4zRecras.nonce,
          payload: payload,
        },
        success: function(response) {
          if (!response || !response.success) {
            const message = response?.data?.message || 'Verzenden mislukt.';
            showFormMessage($form, message, 'error');
            return;
          }

          showFormMessage($form, 'Formulier succesvol verzonden.', 'success');

          const redirectUrl = $form.find('[name="redirectUrl"]').val();

          if (redirectUrl) {
            window.location.href = redirectUrl;
            return;
          }

          $form.trigger('reset');
        },
        error: function(xhr) {
          let response = null;

          try {
            response = JSON.parse(xhr.responseText);
          } catch (e) {
            // Not JSON or unexpected error
          }

          const message = response?.data?.message || 'Verzenden mislukt.';
          const fields  = response?.data?.fields || [];

          // Clear previous errors
          $form.find('.has-error').removeClass('has-error');

          // Mark invalid fields (if provided)
          fields.forEach(function(name) {
            $form.find('[name="' + name + '"]').addClass('has-error');
          });

          showFormMessage($form, message, 'error');
        },
        complete: function() {
          $submitButton.prop('disabled', false);
        }
      })
  });

  function serializeForm($form) {
    const payload = {};

    $form.serializeArray().forEach(function(item) {
      const name = item.name.replace(/\[]$/, '');
      const value = item.value;

      if (payload[name] === undefined) {
        payload[name] = value;
        return;
      }

      // Convert to array if the key already exists
      if (!Array.isArray(payload[name])) {
        payload[name] = [payload[name]];
      }

      payload[name].push(value);
    });

    return payload;
  }

  function validateForm(payload, $form) {
    let isValid = true;
    let firstErrorMessage = null;

    /**
     * Required fields:
     * Uses HTML required attribute as source of truth.
     */
    $form.find('[required]').each(function() {
      const name = this.name;
      const value = payload[name];

      if (!value || String(value).trim() === '') {
        isValid = false;
        firstErrorMessage = 'Vul alle verplichte velden in.';
        return false; // break .each
      }
    });

    if (!isValid) {
      showFormMessage($form, firstErrorMessage, 'error');
      return false;
    }

    Object.keys(payload).forEach(function(key) {
      if (key.toLowerCase().includes('email')) {
        const value = payload[key];

        if (value && value.indexOf('@') === -1) {
          isValid = false;
          firstErrorMessage = 'Voer een geldig e-mailadres in.';
        }
      }
    });

    if (!isValid) {
      showFormMessage($form, firstErrorMessage, 'error');
      return false;
    }

    return true;
  }

  function showFormMessage($form, message, type = "error") {
    const $box = $form.find(".recras-form-message");

    $box.removeClass("is-error is-success").addClass(type === "success" ? "is-success" : "is-error").text(message).prop("hidden", false);
  }


});